// Dynamically calculates and updates the delivery estimate text based on data attributes
(function () {
  function parseCutoff(str) {
    if (!str) return 14 * 60; // default 2pm
    var h = parseInt(str.slice(0, 2), 10);
    var m = parseInt(str.slice(2), 10);
    return h * 60 + m;
  }
  function getExcludedDays(str) {
    if (!str) return [];
    return str.split(',').map((s) => s.trim().toUpperCase());
  }
  function addBusinessDays(date, days, excludeDays) {
    let d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!excludeDays.includes(d.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase().slice(0, 3))) {
        added++;
      }
    }
    return d;
  }

  // New function to handle exclusion modes
  function addDaysWithExclusions(date, days, excludeDays, mode) {
    let d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      let weekday = d.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase().slice(0, 3);
      if (
        (mode === 'processing_day' && added < days - 1 && excludeDays.includes(weekday)) ||
        (mode === 'delivery_day' && added === days - 1 && excludeDays.includes(weekday)) ||
        (mode === 'both' && excludeDays.includes(weekday))
      ) {
        continue;
      }
      added++;
    }
    return d;
  }

  function formatOrdinal(n) {
    const s = ['th', 'st', 'nd', 'rd'],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }
  function formatDate(date, format) {
    if (format === 'dd/MM') {
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' });
    }
    // ordinal: 8th March
    return formatOrdinal(date.getDate()) + ' ' + date.toLocaleDateString('en-US', { month: 'long' });
  }
  function updateDeliveryEstimate() {
    var el = document.querySelector('.delivery-estimate');
    if (!el) return;
    
    // Check if custom text is enabled
    var useCustomText = el.dataset.useCustomText === 'true';
    if (useCustomText) {
      // If custom text is enabled, just show the custom text (already rendered in HTML)
      return;
    }
    
    var startDays = parseInt(el.dataset.estimateStart, 10) || 4;
    var endDays = parseInt(el.dataset.estimateEnd, 10) || 10;
    var cutoff = parseCutoff(el.dataset.cutoff);
    var excludeMode = el.dataset.excludeMode || 'delivery_day';
    var excludeDays = getExcludedDays(el.dataset.excludeDays);
    var dateFormat = el.dataset.dateFormat || 'ordinal';
    var now = new Date();
    var nowMinutes = now.getHours() * 60 + now.getMinutes();
    var shippingOffset = nowMinutes >= cutoff ? 1 : 0;
    var startDate = new Date(now);
    var endDate = new Date(now);

    if (['delivery_day', 'processing_day', 'both'].includes(excludeMode)) {
      startDate = addDaysWithExclusions(startDate, shippingOffset + startDays, excludeDays, excludeMode);
      endDate = addDaysWithExclusions(endDate, shippingOffset + endDays, excludeDays, excludeMode);
    } else {
      startDate.setDate(startDate.getDate() + shippingOffset + startDays);
      endDate.setDate(endDate.getDate() + shippingOffset + endDays);
    }

    var startStr = formatDate(startDate, dateFormat);
    var endStr = formatDate(endDate, dateFormat);
    var rangeStr =
      startDate.getMonth() === endDate.getMonth()
        ? `${formatOrdinal(startDate.getDate())}-${formatOrdinal(endDate.getDate())} ${endDate.toLocaleDateString(
            'en-US',
            { month: 'long' }
          )}`
        : `${startStr}–${endStr}`;
    var cutoffToday = new Date(now);
    cutoffToday.setHours(Math.floor(cutoff / 60), cutoff % 60, 0, 0);
    var diff = cutoffToday - now;
    if (diff < 0) diff += 24 * 60 * 60 * 1000;
    var h = Math.floor(diff / (1000 * 60 * 60));
    var m = Math.floor((diff / (1000 * 60)) % 60);
    
    var timeElement = document.getElementById('delivery-estimate-time');
    var rangeElement = document.getElementById('delivery-estimate-range');
    
    if (timeElement) timeElement.textContent = `${h}h ${m}m`;
    if (rangeElement) rangeElement.textContent = rangeStr;
  }
  document.addEventListener('DOMContentLoaded', updateDeliveryEstimate);
  // Listen for changes to the delivery-estimate element's attributes
  var observer = new MutationObserver(function (mutations) {
    for (var mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.target.classList.contains('delivery-estimate')) {
        updateDeliveryEstimate();
        break;
      }
    }
  });
  var el = document.querySelector('.delivery-estimate');
  if (el) {
    observer.observe(el, { attributes: true });
  }
})();
